"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsHelpers_1 = require("@ledgerhq/coin-framework/bridge/jsHelpers");
const updateTransaction = (tx, patch) => {
    var _a;
    if (("mode" in patch && patch.mode !== tx.mode) ||
        ("validators" in patch && ((_a = patch.validators) === null || _a === void 0 ? void 0 : _a.length) !== tx.validators.length)) {
        patch = Object.assign(Object.assign({}, patch), { gas: null, fees: null });
    }
    return (0, jsHelpers_1.defaultUpdateTransaction)(tx, patch);
};
exports.default = updateTransaction;
//# sourceMappingURL=js-updateTransaction.js.map